export default function BrandMark({ size = "md", inverse = false, className = "" }) {
  return (
    <span
      className={`brand-mark brand-mark--${size} ${inverse ? "brand-mark--inverse" : ""} ${className}`}
      aria-label="buzzer klip"
    >
      <span className="brand-mark__word">
        <span>buzzer</span>
        <span className="brand-mark__signal" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
      </span>
      <span className="brand-mark__klip">klip</span>
    </span>
  );
}
